import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { api } from '../../api/support';
import { performGlobalLogout } from './authSlice';

export const getconversations = createAsyncThunk(
  'support/getconversations',
  async (userId, { rejectWithValue }) => {
    try {
      const token = sessionStorage.getItem('auth_token');

      const response = await api.get(`/chat/user/${userId}/parent`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || { message: 'Failed to listing' });
    }
  }
);

export const postchatimage = createAsyncThunk(
  'support/postchatimage',
  async ({ file, senderId, receiverId }, { rejectWithValue }) => {
    try {
      const token = sessionStorage.getItem('auth_token');

      const formData = new FormData();
      formData.append('file', file);
      formData.append('senderId', senderId);
      formData.append('receiverId', receiverId);

      const response = await api.post('/chat/upload', formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': undefined, 
        },
      });

      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || { message: 'Failed to upload file' });
    }
  }
);

// ═══════════════════════════════════════════════════════════════════════
//  SLICE
// ═══════════════════════════════════════════════════════════════════════

const supportchatSlice = createSlice({
  name: 'support',
  initialState: {
    data: [],          
    lastUploadedFile: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // ── getconversations ────────────────────────────────────────────
      .addCase(getconversations.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getconversations.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getconversations.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || 'Something went wrong';
      })

///
      .addCase(postchatimage.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(postchatimage.fulfilled, (state, action) => {
        state.loading = false;
        state.lastUploadedFile = action.payload; 
      })
      .addCase(postchatimage.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || 'Something went wrong';
      })

      // GLOBAL LOGOUT
      .addCase(performGlobalLogout.fulfilled, (state) => {
        state.data = [];
        state.lastUploadedFile = null;
        state.loading = false;
        state.error = null;
      });
  },
});

export default supportchatSlice.reducer;